export default "__VITE_ASSET__0LYuh8In__"